import * as Period from 'constants/Period';

const BIATHLON_PERIOD_MAP = {};

BIATHLON_PERIOD_MAP[2000] = Period.NOT_STARTED;
BIATHLON_PERIOD_MAP[2002] = Period.LAP_FIRST;
BIATHLON_PERIOD_MAP[2004] = Period.LAP_SECOND;
BIATHLON_PERIOD_MAP[2006] = Period.LAP_THIRD;
BIATHLON_PERIOD_MAP[2008] = Period.LAP_FOURTH;
BIATHLON_PERIOD_MAP[2010] = Period.LAP_FIFTH;
BIATHLON_PERIOD_MAP[2012] = Period.LAP_SIXTH;
BIATHLON_PERIOD_MAP[2014] = Period.LAP_SEVENTH;
BIATHLON_PERIOD_MAP[2016] = Period.LAP_EIGHTH;
BIATHLON_PERIOD_MAP[2017] = Period.FINISHED;

export default BIATHLON_PERIOD_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Biathlon/PeriodMap.js